import controller from './partnerList.controller';
import template from './partnerList.html';

export const partnerListComponent = {
  name: 'partnerListComponent',
  restrict: 'E',
  template,
  controller,
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    header: '@',
    details: '<',
    detailValues: '<',
    partners: '<',
    readonly: '@'
  }
};
